import type { ChartOfAccountCategory } from '../Settings/types'

// Mock data for account categories
const accountCategories: ChartOfAccountCategory[] = [
	{
		uuid: 'uuid1',
		name: 'Tilit',
		rangeStart: 1000,
		rangeEnd: 2000,
		subCategories: [
			{
				uuid: 'uuid1-1',
				name: 'Aineettomat oikeudet',
				rangeStart: 1000,
				rangeEnd: 1069,
				subCategories: [],
			},
			{
				uuid: 'uuid1-2',
				name: 'Liikearvo',
				rangeStart: 1070,
				rangeEnd: 1090,
				subCategories: [],
			},
			{
				uuid: 'uuid1-5',
				name: 'Maa- ja vesialueet',
				rangeStart: 1100,
				rangeEnd: 1129,
				subCategories: [],
			},
			{
				uuid: 'uuid1-6',
				name: 'Liittymät',
				rangeStart: 1130,
				rangeEnd: 1139,
				subCategories: [],
			},
			{
				uuid: 'uuid1-1-7',
				name: 'Rakennukset ja rakennelmat',
				rangeStart: 1140,
				rangeEnd: 1249,
				subCategories: [],
			},
			{
				uuid: 'uuid1-8',
				name: 'Koneet ja kalusto',
				rangeStart: 1250,
				rangeEnd: 1299,
				subCategories: [],
			},
			{
				uuid: 'uuid1-9',
				name: 'Muut aineelliset hyödykkeet',
				rangeStart: 1300,
				rangeEnd: 1379,
				subCategories: [],
			},
			{
				uuid: 'uuid1-10',
				name: 'Ennakkomaksut ja keskeneräiset hankinnat',
				rangeStart: 1380,
				rangeEnd: 1399,
				subCategories: [],
			},
			{
				uuid: 'uuid1-11',
				name: 'Osuudet ja saamiset',
				rangeStart: 1400,
				rangeEnd: 1629,
				subCategories: [],
			},
			{
				uuid: 'uuid1-12',
				name: 'Muut saamiset',
				rangeStart: 1630,
				rangeEnd: 2000,
				subCategories: [],
			},
		],
	},
]

export default accountCategories
